module.exports = __webpack_public_path__ + "img/0xd7D4a2D99314C8D749050FEfA33c5566EB2C5681.64954950.png";